// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4801 ? "1be00864" : chunkId) + "." + {"3808":"424a0c2d5fe3be14","4268":"85cc628348ac30c7","4647":"2bd163163a9c20ec","4801":"9c59d8afdee83366","8848":"f894e1d72d26657e"}[chunkId] + ".js";
};